<template>
    <div id="dashboard">
        <b-row>
            <b-col>
                <filters :monthRange="true" :region="false" :competitors="true" :markets="true" :comparisonYear="true"
                    :dataSource="$t('filter.sourceHesta')" :selectedyear="this.selectedYear" @refresh="setParams" />
            </b-col>
        </b-row>

        <loading v-if="loading" />
        <b-row class="mt-3" v-else>
            <b-col :md="12" :lg="12" :xl="12">
                <b-row class="mt-3">
                    <b-col>
                        <TableCard v-if="this.recapTable.data" :title="$t('dashboard.competitors.title')"
                            :header="this.recapTable.header" :table="this.recapTable.data"
                            :json_fields="this.recapTable.json_fields" :period_info="this.period_details_text" />
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col md="6">
                        <ChartCard v-if="this.evolutionChart.data[0].data"
                            :title="$t('dashboard.competitors.overnights12Months')" :options="this.evolutionChart.options"
                            :data="this.evolutionChart.data" :chartType="this.evolutionChart.type"
                            :period_info="this.period_details_text" />
                    </b-col>
                    <b-col md="6">
                        <ChartCard v-if="this.overYearChart.data[0].data" :title="$t('dashboard.competitors.evoOverYear')"
                            :options="this.overYearChart.options" :data="this.overYearChart.data"
                            :chartType="this.overYearChart.type" :period_info="this.period_details_text" />
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <BenchmarkProvenanceTable v-if="provenanceCard.content" :title="provenanceCard.title"
                            :fields="provenanceCard.header" :items="provenanceCard.content" :benchmark="true"
                            competitorName="Mitbewerber" :period_info="this.period_details_text" hover striped bordered
                            small fixed />
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>


<script>
import DashboardMixins from "@/mixins/api/dashboard";
import TableCard from "@/components/dashboard/TableCard.vue";
import ChartCard from "@/components/dashboard/ChartCard.vue";
import BenchmarkProvenanceTable from "@/components/dashboard/BenchmarkProvenanceTable.vue";

export default {
    mixins: [DashboardMixins],
    components: {
        TableCard,
        ChartCard,
        BenchmarkProvenanceTable,
    },
    data() {
        return {
            competitors: {
                display: true,
                options: null,
                default: 0,
                key: "competitors",
            },
            defaultValues: {
                period: { start: null, end: null },
                maxDate: null,
                minDate: "01-01-2005",
                monthRange: true,
            },
            period_details_text: null,
        }
    },
    methods: {
        setParams(newParams) {
            this.params = newParams;
            this.refreshBenchmark();
        },
    },

}
</script>